import { createAction } from '@ngrx/store';

import { DashboardAdminActionTypes } from './actions.model';

export const init = createAction(DashboardAdminActionTypes.Init);
